<template>
  <div
    v-if="products.length"
    class="profiles">
    <p class="profiles__disclaimer">
      You have pharmacy products in your cart which require some additional information:
    </p>

    <p class="profiles__products">
      <strong>Products:</strong>
      <span
        v-for="product in products"
        :key="product.key">
        {{ product.title }}
      </span>
    </p>

    <div
      v-if="$store.cID == null"
      class="profiles__label-btn">
      <label
        class="profile-label">
        You must be logged in with a profile to continue
      </label>
      <a
        class="profiles__new-btn"
        href="/account">
        Sign in
      </a>
    </div>
    <div
      v-else
      class="profiles__label-btn">
      <label
        class="profile-label"
        for="profile">
        Who is this product for?
      </label>
      <button
        class="profiles__new-btn"
        @click.prevent="showCreateNew = !showCreateNew"
        v-text="showCreateNew ? 'Cancel' : 'Add new profile?'">
      </button>
    </div>

    <select
      v-if="profiles.length"
      class="profile-select"
      id="profile"
      v-model="fullname">
      <option
        v-for="(profile, idx) in profiles"
        :value="profile.fullname"
        :key="idx">
        {{ profile.fullname }}
      </option>
    </select>

    <form
      v-show="showCreateNew"
      class="profiles__form"
      @submit.prevent="createProfile()">
      <h5>New Profile</h5>

      <label
        class="profile-label"
        for="fullname">
        Full Name*
      </label>
      <input
        type="text"
        class="profile-input"
        id="fullname"
        v-model="newProfile.fullname"
        required
      />

      <label
        class="profile-label"
        for="dob">
        Date of Birth (DD/MM/YYYY)*
      </label>
      <input
        type="text"
        class="profile-input"
        id="dob"
        v-model="newProfile.dob"
        required
      />

      <label
        class="profile-label"
        for="gender">
        Gender*
      </label>
      <select
        class="profile-select"
        id="gender"
        v-model="newProfile.gender"
        required>
        <option value="Male" selected>
          Male
        </option>
        <option value="Female">
          Female
        </option>
        <option value="Prefer not to say">
          Prefer not to say
        </option>
      </select>

      <div v-if="newProfile.gender != 'Male'">
        <label
          class="profile-label"
          for="pregnant">
          Is this patient pregnant or breastfeeding?
        </label>
        <select
          class="profile-select"
          id="pregnant"
          v-model="newProfile.pregnant_or_breastfeeding"
          required>
          <option value="No" selected>
            No
          </option>
          <option value="Yes">
            Yes
          </option>
        </select>
      </div>

      <label
        class="profile-label"
        for="address">
        Address*
      </label>
      <input
        type="text"
        class="profile-input"
        id="address"
        v-model="newProfile.address"
        required
      />

      <label
        class="profile-label"
        for="phone">
        Phone*
      </label>
      <input
        type="text"
        class="profile-input"
        id="phone"
        v-model="newProfile.phone"
        required
      />

      <label
        class="profile-label"
        for="patient_allergies">
        Patient Allergies (optional)
      </label>
      <input
        type="text"
        class="profile-input"
        id="patient_allergies"
        v-model="newProfile.patient_allergies"
      />

      <label
        class="profile-label"
        for="patient_conditions">
        Patient Medical Conditions (optional)
      </label>
      <input
        type="text"
        class="profile-input"
        id="patient_conditions"
        v-model="newProfile.patient_conditions"
      />

      <label
        class="profile-label"
        for="patient_medications">
        Patient Medications (optional)
      </label>
      <input
        type="text"
        class="profile-input"
        id="patient_medications"
        v-model="newProfile.patient_medications"
      />

      <div class="profiles__actions-btns">
        <button
          class="btn"
          v-text="loading ? 'Saving' : 'Save'">
        </button>
        <button
          class="btn btn--cancel"
          @click.prevent="showCreateNew = false">
          Cancel
        </button>
      </div>
    </form>

    <div class="profiles__checkbox-wrapper">
      <input
        type="checkbox"
        class="profile-checkbox"
        id="confirm-info"
        v-model="confirmInfo"
        :disabled="!selectedProfile"
        required
      />
      <label
        class="profile-label"
        for="confirm-info">
        I confirm the above medical information is correct.
      </label>
    </div>

    <div class="profiles__checkbox-wrapper">
      <input
        type="checkbox"
        class="profile-checkbox"
        id="confirm-policy"
        v-model="confirmPolicy"
        :disabled="!selectedProfile"
        required
      />
      <label
        class="profile-label"
        for="confirm-policy">
        I agree to the Active Pharmacy <u>privacy policy</u>
      </label>
    </div>

    <div
      v-if="selectedProfile"
      class="profiles__hidden-fields"
      ref="hidden">
      <input
        v-if="selectedProfile.fullname"
        type="hidden"
        name="attributes[Name]"
        :value="selectedProfile.fullname"
      />
      <input
        v-if="selectedProfile.dob"
        type="hidden"
        name="attributes[DOB]"
        :value="selectedProfile.dob"
      />
      <input
        v-if="selectedProfile.gender"
        type="hidden"
        name="attributes[Gender]"
        :value="selectedProfile.gender"
      />
      <input
        v-if="selectedProfile.gender != 'Male'"
        type="hidden"
        name="attributes[Pregnant Or Breastfeeding]"
        :value="selectedProfile.pregnant_or_breastfeeding"
      />
      <input
        v-if="selectedProfile.address"
        type="hidden"
        name="attributes[Address]"
        :value="selectedProfile.address"
      />
      <input
        v-if="selectedProfile.phone"
        type="hidden"
        name="attributes[Phone]"
        :value="selectedProfile.phone"
      />
      <input
        v-if="selectedProfile.patient_allergies"
        type="hidden"
        name="attributes[Allergies]"
        :value="selectedProfile.patient_allergies"
      />
      <input
        v-if="selectedProfile.patient_conditions"
        type="hidden"
        name="attributes[Conditions]"
        :value="selectedProfile.patient_conditions"
      />
      <input
        v-if="selectedProfile.patient_medications"
        type="hidden"
        name="attributes[Medications]"
        :value="selectedProfile.patient_medications"
      />
    </div>
  </div>
</template>

<script>
import { getState } from '../../scripts/cart'

export default {
  name: 'CartProfiles',

  computed: {
    profiles () {
      return this.$store.profiles
    },
    selectedProfile () {
      return this.profiles.length ?
        this.profiles.find(p => p.fullname === this.fullname) :
        null
    },
    validationPassed () {
      return this.selectedProfile != null && this.confirmInfo && this.confirmPolicy
    },
    loading () {
      return this.$store.loading
    }
  },

  data () {
    return {
      loaded: 0,
      products: [],
      confirmInfo: false,
      confirmPolicy: false,
      showCreateNew: false,
      fullname: '',
      newProfile: {
        fullname: '',
        dob: '',
        gender: 'Male',
        pregnant_or_breastfeeding: '',
        address: '',
        phone: '',
        patient_allergies: '',
        patient_conditions: '',
        patient_medications: ''
      }
    }
  },

  created () {
    this.$actions.initProfiles()
    this.updateProducts()
  },

  methods: {
    createProfile () {
      this.$actions.createProfile(this.newProfile)
    },
    updateProducts () {
      getState().then(state => {
        this.products = state.items.flatMap(i => {
          if (!i.properties) return []
          if (!i.properties._tags) return []
          let tags = JSON.parse(i.properties._tags)
          if (tags.includes('pharmacymedicines') || tags.includes('pharmacistonlymedicines') || tags.includes('prescription')) {
            return i
          } else {
            return []
          }
        })
      })
    },
    updateCheckoutBtn () {
      let btnsFound = setInterval(() => {
        let btns = document.querySelectorAll('button[name="checkout"], .btn-checkout')
        if (btns.length) {
          clearInterval(btnsFound)
          if (this.validationPassed || !this.products.length) {
            btns.forEach(b => b.classList.remove('disabled'));
          } else {
            btns.forEach(b => b.classList.add('disabled'));
          }
        }
      }, 100)
    }
  },

  watch: {
    profiles () {
      this.loaded++
      if (this.profiles.length) {
        if (this.loaded > 1) {
          this.fullname = this.fullname = this.profiles[this.profiles.length - 1].fullname
          this.showCreateNew = false
          this.newProfile.fullname = ''
          this.newProfile.dob = ''
          this.newProfile.gender = 'Male'
          this.newProfile.address = ''
          this.newProfile.phone = ''
          this.newProfile.patient_allergies = ''
          this.newProfile.patient_conditions = ''
          this.newProfile.patient_medications = ''
        } else {
          this.fullname = this.profiles[0].fullname
        }
      }
    },
    validationPassed () {
      this.updateCheckoutBtn();
    },
    products () {
      this.updateCheckoutBtn();
    },
    selectedProfile () {
      if (this.selectedProfile) {
        let formFound = setInterval(() => {
          let form = document.querySelectorAll('form[action="/cart"]')
          if (form.length) {
            clearInterval(formFound)
            form.forEach(f => {
              f.querySelector('.ps-hidden-fields').innerHTML = this.$refs.hidden.innerHTML
            })
          }
        }, 100)
      }
    }
  }
}
</script>

<style scoped>
.profiles {
  padding-bottom: 1rem;
}

.profiles__label-btn {
  padding-bottom : 1rem;
  display        : flex;
  justify-content: space-between;
}

.profiles__label-btn label {
  max-width: 14.5rem;
  font-size: .85rem;
}

.profiles__new-btn {
  font-size      : .85rem;
  font-weight    : 600;
  text-decoration: underline;
  color          : red !important;
}

.profile-label {
  margin-bottom : .1rem;
  font-size     : .75rem;
  font-weight   : 300;
  letter-spacing: .025rem;
  text-transform: capitalize;
  user-select   : none;
}

.profile-select,
.profile-input {
  width        : 100%;
  padding      : .25rem .5rem;
  margin-bottom: .75rem;
  border-color : black;
  border-radius: .15rem;
}

.profile-checkbox,
.profile-checkbox + .profile-label {
  display: inline;
}

.profile-checkbox[disabled] + label {
  color: gainsboro;
}

.btn--cancel {
  background: red;
}

.profiles__disclaimer {
  margin-bottom: .5rem;
  font-weight  : 600;
  line-height  : 1.5;
  color        : #2c3a86;
}

.profiles__actions-btns {
  margin-bottom: 1rem;
}

.profiles__checkbox-wrapper {
  display    : flex;
  align-items: center;
}

.profiles__products span:not(:last-of-type)::after {
  display: inline;
  content: ', ';
}
</style>
